module.exports = __webpack_public_path__ + "img/help_message_pl.f7b18bde.png";